import RsBreadcrumbs from '@Pages/RetroSynthesis/RsBreadcrumbs/RsBreadcrumbs';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { fetchProjectBreadcrumbInfoAction, fetchProjectsCountAction } from '@Pages/RetroSynthesis/RsBreadcrumbs/actions';
import { getProjectsInfoMap, getRemovedProjectIds, getRemovedRouteIds } from '@Pages/RetroSynthesis/RsBreadcrumbs/selector';
import { routeType } from '@Pages/RetroSynthesis/ProjectRoute/selectors';

const mapActionToProps = {
  fetchProjectInfo: fetchProjectBreadcrumbInfoAction,
  fetchProjectsCount: fetchProjectsCountAction,
};

const mapStateToProps = (state) => ({
  projectsInfoMap: getProjectsInfoMap(state),
  routeType: routeType(state),
  removedProjectIds: getRemovedProjectIds(state),
  removedRouteIds: getRemovedRouteIds(state),
});

export default connect(mapStateToProps, mapActionToProps)(withRouter(RsBreadcrumbs));
